var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.66 6.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#006493;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "attach") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL_-_ICONS",
    "data-name": "ALL - ICONS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.64,2,1.52,5.11l.26.26L4.89,2.26a.37.37,0,0,1,.52,0,.36.36,0,0,1,0,.51L3.1,5.08l-.26.25-.55.55.26.26.55-.55.25-.26L5.66,3a.74.74,0,0,0,0-1A.72.72,0,0,0,4.64,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.65.5A.8.8,0,0,0,6.52.37a1.27,1.27,0,0,0-1.79,0L.37,4.73a1.27,1.27,0,0,0,1.8,1.79l.38-.38-.26-.26-.38.39a.91.91,0,0,1-1.28,0A.89.89,0,0,1,.63,5L5,.63a.91.91,0,0,1,1.28,0,.74.74,0,0,1,.12.13c.05,0,.6.59.65.64A.91.91,0,0,1,7,2.68l-4,4,.26.26,4-4a1.26,1.26,0,0,0,0-1.79Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachBlue);
export default __webpack_public_path__ + "static/media/attach_blue.488ffacfe052836082e990ee75c406ff.svg";
export { ForwardRef as ReactComponent };